import { unwrapResult } from '@reduxjs/toolkit'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { useActionRunner } from 'src/modules/notification'

import { usePurchasing } from '../hooks'
import {
  createLineItems,
  getFieldErrors,
  orderFormActionOptions,
} from '../utils'
import OrderForm from './OrderForm'

const CreateOrderView = () => {
  const [isRepeatOrderModalOpen, setRepeatOrderModalOpen] = useState(false)
  const [scheduleLaterDate, setScheduleLaterDate] = useState('')

  const handleOpenRepeatOrderModal = () => {
    setRepeatOrderModalOpen(true)
  }

  const handleCloseRepeatOrderModal = () => {
    setRepeatOrderModalOpen(false)
  }

  const handleSaveRepeatOrder = async ({
    repeatOrderSettings,
    values,
    repeatOrderId,
  }) => {
    const lineItems = createLineItems(agreementProducts, values)
    const result = await doCreateDraftOrder({
      environmentId: purchasingEnvironment,
      lineItems,
    })
    const payload = unwrapResult(result)

    const draftOrderId = payload.id

    const schedule = { ...repeatOrderSettings, draftOrderId }

    const response = await doCreateRepeatOrderSchedule({
      draftOrderId: draftOrderId,
      schedule: schedule,
    })

    const repeatOrderPayload = unwrapResult(response)

    if (repeatOrderPayload && draftOrderId) {
      history.push(`/purchasing/scheduled`)
    }
  }

  const {
    createDraftOrder,
    fetchProducts,
    products: agreementProducts,
    purchasingEnvironment,
    createRepeatOrderSchedule,
  } = usePurchasing()

  const history = useHistory()
  const [fetchData, isFetching] = useActionRunner(fetchProducts)
  const [doCreateDraftOrder] = useActionRunner(
    createDraftOrder,
    orderFormActionOptions
  )

  const [doCreateRepeatOrderSchedule] = useActionRunner(
    createRepeatOrderSchedule
  )

  useEffect(() => {
    fetchData(purchasingEnvironment)
  }, [purchasingEnvironment])

  if (isFetching) {
    return null
  }

  const handleSubmit = async (values, { setErrors }) => {
    const lineItems = createLineItems(agreementProducts, values)
    if (lineItems.length > 0) {
      const result = await doCreateDraftOrder({
        environmentId: purchasingEnvironment,
        lineItems,
        scheduleLater: scheduleLaterDate ?? null,
      })

      try {
        const payload = unwrapResult(result)

        if (payload && payload.id && payload.id !== '') {
          history.push(`/purchasing/drafts/${payload.id}`)
        }
      } catch (error) {
        if (error.data?.lineItems) {
          const fieldErrors = getFieldErrors(
            error.data.lineItems,
            lineItems,
            agreementProducts
          )
          setErrors(fieldErrors)
        }
      }
    }
  }

  const handleOnSetScheduleLater = e => {
    setScheduleLaterDate(e.target.value)
  }

  const products = agreementProducts.map(({ product, supplier, price }) => ({
    ...product,
    supplier,
    price: String(price),
  }))

  return (
    <OrderForm
      onSubmit={handleSubmit}
      products={products}
      submitText="Draft Order"
      isModalOpen={isRepeatOrderModalOpen}
      handleOpenModal={handleOpenRepeatOrderModal}
      handleCloseModal={handleCloseRepeatOrderModal}
      handleSaveRepeatOrder={handleSaveRepeatOrder}
      onSetScheduleLater={handleOnSetScheduleLater}
      scheduleLaterValue={scheduleLaterDate}
    />
  )
}

export default CreateOrderView
